export default __webpack_public_path__ + "static/media/stepathon_img.beb18e48.svg";